/**
 * Positions Simple Bundles above inventory, links fields to the product form,
 * and disables OOS options using Simple Bundles' _bundle_selection pattern.
 */
(function () {
  const BUNDLE_ROOT = '[data-simple-bundles-options]';
  const BUNDLE_SELECT = 'select[name^="properties["]';
  const BUNDLE_SELECTION = 'properties[_bundle_selection]';
  const SOLD_OUT_SUFFIX = ' — Sold out';
  const RETRY_DELAYS_MS = [0, 100, 500, 1000, 2000];

  function getBundlesElement() {
    return document.querySelector(BUNDLE_ROOT);
  }

  function getProductForm() {
    return document.querySelector('.js-product-form-main');
  }

  function getInsertBeforeTarget() {
    const inventory = document.querySelector('.product-info product-inventory');
    if (inventory) return inventory;

    const productForm = document.querySelector('.product-info product-form');
    return productForm?.closest('.product-info__block') || productForm;
  }

  function relocateBundles(bundles) {
    const target = getInsertBeforeTarget();
    if (!target || bundles.nextElementSibling === target) return;

    target.parentNode.insertBefore(bundles, target);
  }

  function linkBundlesToForm(bundles) {
    const form = getProductForm();
    if (!form?.id) return;

    bundles.querySelectorAll('select, input').forEach((field) => {
      if (field.name) field.setAttribute('form', form.id);
    });
  }

  function fixSelectIfNeeded(select) {
    const selected = select.options[select.selectedIndex];
    if (selected?.value && !selected.disabled) return;

    const available = Array.from(select.options).find((option) => option.value && !option.disabled);
    if (!available || select.value === available.value) return;

    select.value = available.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function syncBundleSelection(bundles) {
    const values = [];
    bundles.querySelectorAll(BUNDLE_SELECT).forEach((select) => {
      fixSelectIfNeeded(select);
      const option = select.options[select.selectedIndex];
      if (option?.value && !option.disabled) values.push(option.value);
    });

    if (!values.length) return;

    let input = bundles.querySelector(`input[name="${BUNDLE_SELECTION}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = BUNDLE_SELECTION;
      bundles.appendChild(input);
    }

    input.value = values.join(' <> ');
    linkBundlesToForm(bundles);
  }

  function disableOutOfStock(bundles) {
    bundles.querySelectorAll(`${BUNDLE_SELECT} option[data-inventory]`).forEach((option) => {
      if (!option.value) return;

      if (!option.dataset.bundleLabel) {
        option.dataset.bundleLabel = option.textContent.replace(SOLD_OUT_SUFFIX, '').trim();
      }

      const outOfStock = Number(option.getAttribute('data-inventory')) < 1;
      option.disabled = outOfStock;

      if (outOfStock) {
        option.removeAttribute('selected');
      }

      option.textContent = outOfStock
        ? `${option.dataset.bundleLabel}${SOLD_OUT_SUFFIX}`
        : option.dataset.bundleLabel;
    });

    syncBundleSelection(bundles);
  }

  function bindBundleHandlers(bundles) {
    if (bundles.dataset.bundleHandlersBound === 'true') return;
    bundles.dataset.bundleHandlersBound = 'true';

    bundles.addEventListener('change', (event) => {
      if (!event.target.matches(BUNDLE_SELECT)) return;
      syncBundleSelection(bundles);
    });
  }

  function bindFormSubmitSync() {
    if (document.documentElement.dataset.bundleFormSyncBound === 'true') return;
    document.documentElement.dataset.bundleFormSyncBound = 'true';

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form?.matches?.('.js-product-form-main')) return;

      const bundles = getBundlesElement();
      if (bundles) syncBundleSelection(bundles);
    }, true);
  }

  function processBundles(bundles) {
    relocateBundles(bundles);
    bundles.classList.add('product-info__block', 'product-info__block--sm', 'simple-bundles-in-product-info');
    linkBundlesToForm(bundles);
    bindBundleHandlers(bundles);
    disableOutOfStock(bundles);
  }

  function watchBundles(bundles) {
    processBundles(bundles);
    RETRY_DELAYS_MS.forEach((delay) => {
      setTimeout(() => disableOutOfStock(bundles), delay);
    });

    if (bundles.dataset.oosWatchBound === 'true') return;
    bundles.dataset.oosWatchBound = 'true';

    let pending = null;
    new MutationObserver(() => {
      clearTimeout(pending);
      pending = setTimeout(() => {
        linkBundlesToForm(bundles);
        disableOutOfStock(bundles);
      }, 50);
    }).observe(bundles, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-inventory', 'disabled', 'selected'] });
  }

  function init() {
    bindFormSubmitSync();

    const bundles = getBundlesElement();
    if (bundles) {
      watchBundles(bundles);
      return;
    }

    const root = document.querySelector('.product-info') || document.body;
    const observer = new MutationObserver(() => {
      const el = getBundlesElement();
      if (!el) return;
      watchBundles(el);
      observer.disconnect();
    });

    observer.observe(root, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
